export function getInitialOfName(name: string) {
	const names = name.trim().split(" ");
	return names.map((n) => n.charAt(0).toUpperCase()).join("");
}
